import { CommApiInstance } from "Utils/CommApiInstance";


const FaqCtgrLstInqApi = async (
    GameSvcCd:string,
    CtgrCd:string,
) => {
    return await CommApiInstance.post(`comm/${GameSvcCd}/${CtgrCd}/ctgr_lst`,{
        apiBody: {
        }
    })
    .then((Resp) => Resp.data);
}

export default FaqCtgrLstInqApi;